import React, { useState, useEffect } from "react";
import AxiosInstance from "../../utils/AxiosInstance";
import { toast, ToastContainer } from "react-toastify";
import { Reviews } from "./Reviews";
import { ReviewSModal } from "../Residence/ReviewsModa";

const ReviewHome = () => {
	const [reviews, setReviews] = useState();
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setIsLoading(true);
		const fetchReviews = async () => {
			try {
				const res = await AxiosInstance({
					method: "get",
					url: `/api/v1/reviews`,
					headers: {
						"Content-Type": "application/json",
					},
				});

				setReviews(res.data.message);
				console.log(res);
				setIsLoading(false);
			} catch (err) {
				if (err?.response?.data?.message) {
					toast.error(err.response.data.message, { position: "top-center" });
				}
			}
		};

		const timer = setTimeout(() => fetchReviews(), 2000);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div>
			{isLoading ? (
				<div id="dash-loading" />
			) : (
				<div className="row">
					<div className="col-md-7 col-sm-12 review-container">
						<ToastContainer className="top-margin" />
						<h2 className="text-center">Current UnRead Messages</h2>
						{reviews?.length > 0 &&
							reviews
								.filter((review) => !review.read)
								.slice(0, 30)
								.map((item) => (
									<>
										<div key={item?._id}>
											<Reviews review={item} name={item?.residence?.name} />
										</div>
									</>
								))}
						{reviews?.length > 5 && (
							<ReviewSModal
								reviews={reviews.filter((review) => !review.read)}
								name="Current Unread Messages"
							/>
						)}
					</div>
					<div className="col-md-5 col-sm-12 review-container">
						<h2 className="text-center">Current Read Messages</h2>
						{reviews?.length > 0 &&
							reviews
								.filter((review) => review.read)
								.slice(0, 30)
								.map((item) => (
									<div key={item?._id}>
										<Reviews review={item} name={item?.residence?.name} />
									</div>
								))}

						{reviews?.length > 5 && (
							<ReviewSModal
								reviews={reviews.filter((review) => review.read)}
								name="Current Read Messages"
							/>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default ReviewHome;
